import React from 'react';
import { useGame } from '../context/GameContext';
import Score from './Score';
import '../styles/Header.css';

const Header = () => {
  const { score, bestScore, restartGame } = useGame();

  return (
    <header className="header">
      <div className="header-title">
        <h1>2048</h1>
        <div className="subtitle">Join the tiles, get to <strong>2048!</strong></div>
      </div>
      <div className="header-scores">
        <Score title="SCORE" value={score} />
        <Score title="BEST" value={bestScore} />
      </div>
      <div className="header-actions">
        <button className="restart-button" onClick={restartGame}>
          New Game
        </button>
        <div className="how-to-play">
          <p>
            <strong>HOW TO PLAY:</strong> Use your arrow keys or swipe to move the tiles.
            When two tiles with the same number touch, they merge into one!
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header;